<template>
    <div>
        <v-alert v-if="errorData !== null" type="error" class="mb-1">
            {{ errorData }}
        </v-alert>
    </div>
</template>
<script>
const API_URL = import.meta.env.VITE_API_URL;
import axios from 'axios';
export default {
    name: 'lm-api-client',
    emits: ['onServerEvent'],
    data() {
        return {     
            errorData: null,
            validationErrors: null,
            eventSource: null,
        }
    },
    props: {
        listenToEvents: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        axiosConfig() {
            let vm = this;
            var headers = {};
            var token = "";
            if (vm.$store.state.account !== null && vm.$store.state.account.token)
                token = vm.$store.state.account.token.accessToken;            
            headers = {
                'Authorization': 'Bearer ' + token,                    
                'Content-Type': 'application/json;charset=UTF-8'
            };
            var config = {
                withCredentials: true,
                headers: headers
            };
            return config;
        },
    },
    mounted() {
        const vm = this;
        vm.init();
    },
    methods: {
        init() {
            const vm = this;
            if (vm.listenToEvents) {
                vm.initEventsListener();
            }            
        },
        get(url, successFunc, errorFunc) {
            var vm = this;
            vm.errorData = null;
            vm.validationErrors = null;
            axios.get(API_URL + '/' + url, vm.axiosConfig)                
            .then(response => { 
                if (response.data) {
                    if (successFunc) successFunc(response.data);
                }
            })
            .catch(e => {
                vm.handleResponseError(e, errorFunc);               
            });
        },   
        async getAsync(url) {
            const vm = this;
            return new Promise((resolve, reject) => {
                vm.get(url,
                    data => resolve(data),
                    err => reject(err)
                );
            });            
        },
        post(url, postData, successFunc, errorFunc) {
            var vm = this;
            vm.errorData = null;
            vm.validationErrors = null;
            axios.post(API_URL + '/' + url, postData, vm.axiosConfig)
            .then(response => {
                if (response.data) {
                    if (successFunc) successFunc(response.data);
                }
            })
            .catch(e => {
                vm.handleResponseError(e, errorFunc);
            });
        },
        async postAsync(url, postData) {
            const vm = this;
            return new Promise((resolve, reject) => {
                vm.post(url,
                    postData,
                    data => resolve(data),
                    err => reject(err)
                );
            });            
        },
        initEventsListener() {
            const vm = this;
            vm.eventSource = new EventSource('http://' + vm.device.DeviceInfo.IpAddress+ '/hub');
            vm.eventSource.addEventListener('image-changed', () => {
                console.log('Server event received: image-changed');
                vm.$emit('onServerEvent', 'image-changed');
            });
        },
        handleResponseError(err, errorFunc) {
            const vm = this;
            if (err && err.response && err.response.data && err.response.data.error_description) {
                vm.errorData = err.response.data.error_description;
            } else if (err && err.message) {
                vm.errorData = err.message;
            } else {
                vm.errorData = "Fehler beim Verarbeiten der Anfrage";
            }
            if (errorFunc) {
                errorFunc(err);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
</style>